import * as React from 'react';

import { useSelector } from 'react-redux';
import { PageRedesigned } from './PageRedesigned';
import { checkFsk } from '../../selectors';
import { PageFSK } from './PageFSK';

export const PageContainer = () => {
  const isFsk = useSelector(checkFsk);

  if (isFsk) {
    return <PageFSK />;
  }

  return <PageRedesigned />;
};
